import { Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
  },
];
